import axios from "../shared/axios";
import * as events from './events';
import SystemHelper from "../shared/systemHelper";

export function getRfqQuote(rfqquotationid) {
  return axios.get(`/api/RequestForQuoteQuotation/GetRfqQuotation?rfqquotationid=${rfqquotationid}`);
}
export function saveRfqQuote(data) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/RequestForQuoteQuotation/SaveRfqQuotation`, data)
      .then((result) => {
        switch (data.actioncode) {
          case 'QUOTE_CREATE':
            events.onNotification_CREATED();
            break;
          case 'QUOTE_SAVE_DRAFT':
            events.onNotification_DRAFT_SAVED();
            break;
          case 'QUOTE_COMMUNICATE':
            events.onNotification_COMMUNICATED();
            break;
          case 'QUOTE_REPLY_DRAFT':
            events.onNotification_REPLY_DRAFT_SAVED();
            break;
          case 'QUOTE_REPLY_SEND':
            events.onNotification_REPLY_SENT();
            break;
          default:
            alert('Unknown action code!');
            break;
        }
        resolve(result);
      })
      .catch((error) => reject(error));
  });
}
// export function getRfqQuotes(
//   companyid,
//   projectid,
//   contractid,
//   requestforquoteid
// ) {
//   return axios.post(
//     `/api/RequestForQuoteQuotation/LoadRfqQuotationsList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}&requestforquoteid=${requestforquoteid}`
//   );
// }

export function deleteQuoteDraft(rfqquotationid) { /////not working
  return new Promise((resolve, reject) => {
    axios.post(`api/RequestForQuoteQuotation/DeleteDraft?rfqquotationid=${rfqquotationid}`)
      .then(result => {
        events.onNotification_DELETED();
        resolve(result);
      })
      .catch(error => reject(error));
  })
}

export function importQuotations(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await axios.post(`/api/RequestForQuoteQuotation/Import`, data);
      events.onNotification_CREATED();
      resolve(result);
    }
    catch (err) {
      reject(err)
    }
  });
}

export function deleteQuotationDrafts(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await axios.delete(`/api/RequestForQuoteQuotation/BulkDeleteDraft`, { data: data });
      events.onNotification_DELETED();
      resolve(result);
    }
    catch (err) {
      reject(err)
    }
  });
}

export function communicateQuotationDrafts(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await axios.put(`/api/RequestForQuoteQuotation/BulkCommunicate`, data);
      events.onNotification_COMMUNICATED();
      resolve(result);
    }
    catch (err) {
      reject(err)
    }
  });
}

export function getAcceptedQuotation(requestforquoteid) {
  return axios.get(`/api/RequestForQuoteQuotation/GetAcceptedQuotation`, { params: { requestforquoteid } });
}

export function getRfqQuotationReducedV2(companyid, contractid, requestforquoteid, showDrafts) {
  return axios.post(`/api/RequestForQuoteQuotation/RegisterListV2`, {
    showDrafts: showDrafts,
    showCustomFields: SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.CUSTOM_FIELDS_ENABLED),
    excludeTagHeaders: true,
  },
    { params: { companyid, contractid, requestforquoteid } });
}